<template>
  <article class="layout-section -bg-primary">
    <div class="layout-section__hgroup">
      <h2 class="layout-section__title">{{ wp.promote.title }}</h2>
    </div>

    <div class="rte" v-html="wp.promote.content" />
  </article>
</template>

<script>
export default {
  name: 'AboutPromote',
  inject: ['wp']
}
</script>
